import axios from "axios";

export function getYoutubeDetailsById(vid) {
  return axios.get("https://www.youtube.com/oembed?url=https://www.youtube.com/watch%3Fv=" + vid + "&format=json");
}

export function getYoutubeVideos(searchParamModel) {
  const config = {
    params: {
      nextPageToken: searchParamModel.nextPageToken,
      searchItems: searchParamModel.searchItems,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Video/getYoutubeVideos", config);
}
